
import React, { Component } from 'react'
import { Link } from 'react-router'
import * as R from 'ramda'
import { connect } from 'react-redux'
import Moment from 'moment'

import TextField from 'material-ui/TextField'
import {List, ListItem} from 'material-ui/List'
import {grey400} from 'material-ui/styles/colors';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import Badge from 'material-ui/Badge';



import AttachmentRender from '../AttachmentRender'
import NotificationCard from '../NotificationCard'

import notifications from 'actions/notifications'
import dataActions from 'actions/dataActions'

import { currentUserNotifications, currentUserOpenNotifications } from 'selectors/notifications'
import { managers } from 'selectors/entities'

let select = state => ({
	currentUserOpenNotifications: currentUserOpenNotifications(state)
  , managers: managers(state)
})
export class Notifications extends Component {
  constructor(props){
    super(props)
    this.state={
      showList: false//Trigger to show list of notifications or not
    }
  }

  render(){
	let { props } = this
	let isMob = typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight)
    let { showList } = this.state
    return(
      <div
        className="notify-holder"
      >
	        <div style={{userSelect: "none",
						WebkitUserSelect: "none",
						MozUserSelect: "-moz-none",
						KhtmlUserSelect: "none",
						MsUserSelect: "none"}}
	          className={`notify-icon-holder ${(showList)? 'focused': ''}`}
	          onClick={()=> {
	            this.setState({showList: !showList})
				document.body.onclick = () => {
					this.setState({showList: false})
					document.body.onclick = () => true
				}
	          }}
	        >
				{(props.currentUserOpenNotifications.length)?
					<Badge
						badgeContent={props.currentUserOpenNotifications.length}
						secondary={true}
						badgeStyle={{top: '-15px', right: '-12px'}}
						style={{
							padding: ''
						}}
					>
						<img
							className="notify-trigger"
							src={'/' + process.env.REACT_APP_NAME + "/static/img/bell-white.png"}
						/>
					</Badge>
					:
						<img
							className="notify-trigger"
							src={'/' + process.env.REACT_APP_NAME + "/static/img/bell-green.png"}
						/>
				}
        	</div>
        <div
          style={{
              maxWidth: (this.props.id)? 'auto' : '800px'
              , margin: "auto"
              , marginTop: "0"
              , overflowY: "auto"
              , maxHeight: "300px"
              , paddingRight: "0"
          }}
          className="notification-list"
        >
          <List
            style={{
              display: (showList)? 'block' : 'none'
            }}
          >
            {(props.currentUserOpenNotifications)?
				R.map((notification, index) =>
					<NotificationCard notificationID={notification._id} />
				, R.reverse(R.sortBy(R.prop('createdAt'), R.values(props.currentUserOpenNotifications)))
				)
                : ""
            }
          </List>
        </div>
      </div>
    )
  }
}

export default connect(select, R.mergeAll([dataActions, notifications]))(Notifications)



// WEBPACK FOOTER //
// ./src/components/ListLayoutParts/Notifications.js